// extracted by css-extract-rspack-plugin
export default {"qualityButton":"qualityLevels-styles-qualityButton-92de6d78","qualityButtonContainer":"qualityLevels-styles-qualityButtonContainer-8e79f4b6"};